import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
// OWN
import { PrettyConsole } from '@app/shared/utils';
import { NotificationsClient } from '@tech/api-clients/receipts';

enum NotificationMessageType {
  SUCCESS,
  ERROR,
  INFO,
  WARNING,
}

interface NotificationMessage {
  Type: NotificationMessageType;
  Message: string;
}

export interface NotificationMessageData {
  type: 'success' | 'error' | 'warning' | 'info';
  msg: string;
}

@Injectable({
  providedIn: 'root',
})
export class NotificationhubService extends NotificationsClient {
  private reconnectDelay = 3000;
  private maxRetries = 5;
  connectSSE(
    userId: string,
    baseUrl: string
  ): Observable<NotificationMessageData> {
    return new Observable<NotificationMessageData>((observer) => {
      let event_source: EventSource | null;
      let retries = 0;
      const connect = (userId: string, baseUrl: string) => {
        const url = `${baseUrl}/api/notifications/stream?userId=${userId}`;
        PrettyConsole.INFO(`Connecting to SSE (${url})...`);
        event_source = new EventSource(url);
        window.sseConnections!.push(event_source);
        event_source.onmessage = (event) => {
          let msg: NotificationMessage = JSON.parse(event.data);
          let type: 'info' | 'success' | 'warning' | 'error' = 'info';
          switch (msg.Type) {
            case NotificationMessageType.SUCCESS:
              type = 'success';
              PrettyConsole.SUCCESS(`Received ${event.data}`);
              break;
            case NotificationMessageType.ERROR:
              type = 'error';
              PrettyConsole.ERROR(`Received ${event.data}`);
              break;
            case NotificationMessageType.INFO:
              type = 'info';
              PrettyConsole.INFO(`Received ${event.data}`);
              break;
            case NotificationMessageType.WARNING:
              type = 'warning';
              PrettyConsole.WARNING(`Received ${event.data}`);
              break;
            default:
              type = 'info';
              PrettyConsole.INFO(`Received ${event.data}`);
              break;
          }
          observer.next({ type: type, msg: msg.Message });
        };

        event_source.onerror = (err) => {
          PrettyConsole.ERROR(`SSE error ${err}`);
          event_source?.close();
          event_source = null;

          if (retries < this.maxRetries) {
            retries++;
            const delay = this.reconnectDelay * retries;
            PrettyConsole.WARNING(
              `Reconnecting in ${delay / 1000}s (attempt ${retries})`
            );
            setTimeout(() => connect(userId, baseUrl), delay);
          } else {
            PrettyConsole.ERROR('Max retries reached, stoping SSE.');
            observer.complete();
          }
        };
      };

      connect(userId, baseUrl);

      // Limpieza cuando se desuscribe
      return () => {
        PrettyConsole.INFO('Closing SSE connection.');
        event_source?.close();
      };
    });
  }
}
